import { Link } from "react-router-dom";
import { companyInfo } from "../../data/siteData";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="site-footer">
      <div className="container-shell footer-grid">
        <div data-testid="footer-brand-block" className="footer-column">
          <h3 data-testid="footer-company-name" className="footer-title">
            {companyInfo.name}
          </h3>
          <p data-testid="footer-tagline" className="footer-text">
            {companyInfo.tagline}
          </p>
          <p data-testid="footer-address" className="footer-text">
            {companyInfo.addressLine1}, {companyInfo.addressLine2}
          </p>
        </div>

        <div data-testid="footer-navigation-block" className="footer-column">
          <h4 data-testid="footer-navigation-title" className="footer-subtitle">
            Navigation
          </h4>
          <Link data-testid="footer-home-link" to="/" className="footer-link">
            Home
          </Link>
          <Link data-testid="footer-gallery-link" to="/gallery" className="footer-link">
            Gallery
          </Link>
          <Link data-testid="footer-careers-link" to="/careers" className="footer-link">
            Careers
          </Link>
          <Link data-testid="footer-contact-link" to="/contact" className="footer-link">
            Contact
          </Link>
        </div>

        <div data-testid="footer-contact-block" className="footer-column">
          <h4 data-testid="footer-contact-title" className="footer-subtitle">
            Project Inquiries
          </h4>
          <a data-testid="footer-phone-link" href="tel:+17134667322" className="footer-link">
            {companyInfo.phone}
          </a>
          <a
            data-testid="footer-email-link"
            href={`mailto:${companyInfo.email}`}
            className="footer-link"
          >
            {companyInfo.email}
          </a>
          <p data-testid="footer-established" className="footer-text">
            {companyInfo.founded}
          </p>
        </div>
      </div>
      <div data-testid="footer-copyright" className="footer-bottom">
        © {new Date().getFullYear()} Wayne Iron Works. Built for structural confidence.
      </div>
    </footer>
  );
};
